import { formatUnixDateTime } from '@/shared/lib/datetime';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { fetchStatStoLogs } from './api';
import { dateRangeFilters, monthFilter, placeFilters } from './filters';

interface StoLogRow extends ListRow {
  id: number;
  create_time?: number;
  user_id?: number;
  country?: { name?: string } | null;
  city?: { name?: string } | null;
  work_type_ids?: Array<{ name?: string }> | null;
  count_services?: number | string;
  services_ids?: Array<number | string> | null;
}

const config: ListPageConfig<StoLogRow> = {
  queryKey: 'stat-sto-list',
  title: 'Статистика',
  boxTitle: 'Показы СТО',
  errorText: 'Ошибка загрузки показов СТО',
  fetchList: fetchStatStoLogs,
  rows: ['logs'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id лога' },
    { value: 'user_id', label: 'Поиск по id пользователя' },
    { value: 'count_services', label: 'Поиск по кол-ву показанных СТО (от)' },
    { value: 'service_id', label: 'Поиск по ID показанных СТО' },
  ],
  filters: [...dateRangeFilters(), monthFilter, ...placeFilters()],
  columns: [
    { header: 'ID', render: (row) => row.id },
    {
      header: 'Дата и время запроса',
      sortField: 'create_time',
      render: (row) => formatUnixDateTime(row.create_time),
    },
    { header: 'Пользователь (ID)', render: (row) => row.user_id },
    {
      header: 'Страна / Город',
      render: (row) => [row.country?.name, row.city?.name].filter(Boolean).join(', '),
    },
    {
      header: 'Выбранные услуги',
      render: (row) => row.work_type_ids?.map((work) => work.name).join(', '),
    },
    { header: 'Кол-во показанных СТО', render: (row) => row.count_services },
    {
      header: 'ID показанных СТО',
      render: (row) => <span style={{ maxWidth: 800, display: 'block' }}>{row.services_ids?.join(', ')}</span>,
    },
  ],
};

export const StatStoListPage = () => <GenericListPage config={config} />;
